const careers = [
    {
      title: "HR Project Officer",
      id:"1",
      details: [
        "Tunis/Sfax",
        "Permanent contract | 100% Remote",
        "Occasional assignments possible in Canada/Europe"
      ],
      detailData: {
        id:"1",
        title: "HR Project Officer",
        subtitle:
          "MyOutsourcing is an innovative Tunisian company providing qualified talent—employed by MyOutsourcing—to consulting, audit, and accounting firms based in Canada and Europe. These talents work 100% remotely from Tunisia. We combine flexibility, stability, attractive compensation, and international exposure.",
        sections: [
          {
            title: "Your responsibilities:",
            points: [
              "Manage the HR cycle: recruitment, onboarding, personnel administration, and reporting",
              "Coordinate evaluations, career plans, and performance management",
              "Contribute to cross-functional HR projects: digitization, employee retention, workplace well-being, and company culture"
            ]
          },
          {
            title: "Why join us:",
            points: [
              "100% permanent remote work",
              "Attractive fixed + variable compensation",
              "Opportunity for short-term assignments in Canada or Europe",
              "Continuous training, certifications, and career advancement",
              "Close supervision and international environment"
            ]
          },
          {
            title: "Profile sought:",
            points: [
              "Bachelor’s or Master’s degree (Bac+3/5) in HR or Management",
              "Entry-level candidates accepted or with initial experience",
              "Strong command of French and English is essential",
              "Proficient in office tools (Excel, Word, PowerPoint), autonomous, meticulous, and good interpersonal skills",
            ]
          }
        ]
      }
    },
    {
      title: "IT Audit Consultant",
      id:"2",
      details: [
        "Tunis/Sfax",
        "Permanent contract | 100% Remote",
        "Occasional assignments possible in Canada/Europe"
      ],
      detailData: {
        id:"2",
        title: "IT Audit Consultant",
        subtitle:
          "MyOutsourcing is an innovative Tunisian company providing qualified talent—employed by MyOutsourcing—to consulting, audit, and accounting firms based in Canada and Europe. These talents work 100% remotely from Tunisia. We combine flexibility, stability, attractive compensation, and international exposure.\n\n As part of the development of our IT Audit division, we are recruiting a consultant specialized in information systems auditing.",
        sections: [
          {
            title: "Your responsibilities:",
            points: [
              "Conduct audits of information systems and compliance",
              "Support clients in implementing internal control frameworks",
              "Participate in IT transformation projects, including data migration reviews",
              "Actively contribute to all mission phases: scoping, fieldwork, reporting",
              "Contribute to internal and external development efforts (training, publications, research)"
            ]
          },
          {
            title: "Why join us:",
            points: [
              "Permanent remote work from Tunisia",
              "Attractive fixed and variable compensation",
              "Occasional short-term assignments in Canada or Europe",
              "Continuous training, certifications (CISA, COBIT, ITIL…), and growth opportunities",
              "Close-knit management and multicultural environment"
            ]
          },
          {
            title: "Profile sought:",
            points: [
              "Engineering degree or Master’s in Information Systems Management or equivalent",
              "At least 2 years of experience in IT audit or IT consulting",
              "Fluent in French (spoken and written)",
              "Detail-oriented, well-organized, and a good team player",
              "Proactive, autonomous, and strong writing skills"
            ]
          }
        ]
      }
    },
    {
      title: "Junior Accounting Consultant",
      id:"3",
      details: [
        "Tunis/Sfax",
        "Permanent contract | 100% Remote",
        "Occasional assignments possible in Canada/Europe"
      ],
      detailData: {
        id:"3",
        title: "Junior Accounting Consultant",
        subtitle:
          "MyOutsourcing is an innovative Tunisian company providing qualified talent—employed by MyOutsourcing—to consulting, audit, and accounting firms based in Canada and Europe. These talents work 100% remotely from Tunisia. We combine flexibility, stability, attractive compensation, and international exposure.",
        sections: [
          {
            title: "Your responsibilities:",
            points: [
              "Support monthly financial closings",
              "Perform checks to ensure data integrity",
              "Prepare accurate financial reports for management",
              "Participate in the analysis of monthly and quarterly figures",
              "Provide reliable insights to stakeholders"
            ]
          },
          {
            title: "Why join us:",
            points: [
              "100% permanent remote work",
              "Attractive fixed + variable compensation",
              "Opportunity for short-term assignments in Canada or Europe",
              "Continuous training, certifications, and professional growth",
              "Close supervision and international work environment"
            ]
          },
          {
            title: "Profile sought:",
            points: [
              "Degree in accounting, finance, or equivalent",
              "Entry-level accepted",
              "Excellent understanding of accounting processes",
              "Strong command of French and English",
              "Excellent proficiency in Excel and PowerPoint",
              "Analytical mindset, proactivity, rigor, and team spirit"
            ]
          }
        ]
      }
    },
    {
      title: "Management Control Consultant – Monthly Closings",
      id:"4",
      details: [
        "Tunis/Sfax",
        "Permanent contract | 100% Remote",
        "Occasional assignments possible in Canada/Europe"
      ],
      detailData: {
        id:"4",
        title: "Management Control Consultant – Monthly Closings",
        subtitle:
          "MyOutsourcing is an innovative Tunisian company providing qualified talent—employed by MyOutsourcing—to consulting, audit, and accounting firms based in Canada and Europe. These talents work 100% remotely from Tunisia. We combine flexibility, stability, attractive compensation, and international exposure.\n\n As part of our development, we are hiring an experienced consultant in management control and monthly closings.",
        sections: [
          {
            title: "Your responsibilities:",
            points: [
              "Participate in monthly financial closings",
              "Perform checks to ensure data integrity",
              "Prepare reliable financial reports for management",
              "Oversee financial control activities (monthly and quarterly reviews and analysis)",
              "Provide comprehensive and accurate financial information to stakeholders"
            ]
          },
          {
            title: "Daily tasks:",
            points: [
              "Execute processes in the ERP",
              "Prepare and analyze financial reports",
              "Monitor internal controls",
              "Oversee and develop income statements",
              "Contribute to budget preparation"
            ]
          },
          {
            title: "Why join us:",
            points: [
              "100% permanent remote work",
              "Attractive fixed + variable compensation",
              "Opportunity for short-term assignments in Canada or Europe",
              "Continuous training, certifications, and career development",
              "Close management and international work environment"
            ]
          },
          {
            title: "Profile sought:",
            points: [
              "Bachelor’s in accounting, finance, business administration, mathematics, economics, or related field",
              "Minimum 3 years of experience in accounting, audit, or finance",
              "Excellent communication skills, rigor, and time management",
              "Advanced Excel and PowerPoint skills",
              "Ability to handle large volumes of data",
              "Familiarity with reporting tools like Planning Analytics",
              "Fluency in French and English"
            ]
          }
        ]
      }
    },
    {
      title: "Junior Consultant – Fund Reporting (OPERATE)",
      id:"5",
      details: [
        "Tunis/Sfax",
        "Permanent contract | 100% Remote",
        "Occasional assignments possible in Canada/Europe"
      ],
      detailData: {
        id:"5",
        title: "Junior Consultant – Fund Reporting (OPERATE)",
        subtitle:
          "MyOutsourcing is an innovative Tunisian company providing qualified talent—employed by MyOutsourcing—to consulting, audit, and accounting firms based in Canada and Europe. These talents work 100% remotely from Tunisia. We combine flexibility, stability, attractive compensation, and international exposure.\n\n As part of our growth, we are hiring 4 junior consultants for our Fund Reporting (OPERATE) activity.",
        sections: [
          {
            title: "Your responsibilities:",
            points: [
              "Prepare and clean work files (remove old data, prepare empty templates)",
              "Update reports following changes in prospectuses or legal documents",
              "Adjust wording based on report type and received data",
              "Convert, combine, and update financial data (Word/Excel)",
              "Check Excel formulas and ensure file consistency",
              "Track and update production schedules",
              "Participate in quality review: layout, integration of comments",
              "Prepare and update KPI reports for production monitoring"
            ]
          },
          {
            title: "Daily tasks:",
            points: [
              "Invoice entry using OCR",
              "Anomaly management and follow-up",
              "Entry of daily reports",
              "Collect and verify payment-related information",
              "Review supplier files and assign purchase order (PO) numbers",
              "Verify invoice compliance with PO and receipt of goods/services",
              "Daily reporting production"
            ]
          },
          {
            title: "Why join us:",
            points: [
              "100% permanent remote work",
              "Attractive fixed + variable compensation",
              "Opportunity for short-term assignments in Canada or Europe",
              "Continuous training, certifications, and professional development",
              "Close supervision and international work environment"
            ]
          },
          {
            title: "Profile sought:",
            points: [
              "Master’s in audit, finance, accounting, economics, or equivalent discipline; or Bachelor’s with experience in audit, accounting, or investment funds",
              "Strong analytical skills and results-oriented",
              "Creativity, autonomy, and ability to suggest new ideas and solutions",
              "Excellent communication skills"
            ]
          }
        ]
      }
    },{
      title: "Payables Accounting Consultant",
      id:"6",
      details: [
        "Tunis/Sfax",
        "Permanent Contract (CDI) | 100% Remote Work",
        "Occasional assignments possible in Canada or Europe",
      ],
      detailData: {
        id:"6",
        title: "Payables Accounting Consultant",
        subtitle: "MyOutsourcing is an innovative Tunisian company that provides qualified, Tunisia-based remote employees to consulting, audit, and accounting firms located in Canada and Europe. We offer a combination of flexibility, stability, competitive compensation, and international exposure.\n\n We are hiring a Payables Accounting Consultant to strengthen our remote team.",
        sections: [
          { title: "Your Responsibilities:", points: [
            "Record transactions, process invoices, and verify financial data",
            "Maintain accurate records of supplier liabilities",
            "Ensure accuracy of financial documents for payment, audit, and tax purposes",
            "Prevent unintentional overpayments",
            "Provide effective follow-up to ensure timely supplier payments",
          ] },
          { title: "Daily Tasks:", points: [
            "Invoice entry using OCR tools",
            "Manage discrepancies and follow-up actions",
            "Enter daily reports",
            "Collect and verify payment-related information",
            "Review supplier files and assign purchase order (PO) numbers",
            "Verify invoice compliance with POs and receipt of goods/services",
            "Produce daily reporting"
        ] },
          { title: "Why Join Us:", points: [
            "Permanent remote work from Tunisia",
            "Attractive fixed and variable compensation",
            "Possibility of occasional travel to Canada or Europe",
            "Continuous training, certifications, and career development",
            "Supportive management and multicultural environment",
        ] },
        { title: "Profile Sought:", points: [
          "Degree in accounting, finance, economics, or business management",
          "Knowledge of basic accounting and journal entries",
          "Attention to detail, analytical and organizational skills",
          "Strong numerical and communication skills (written and oral)",
          "Ability to proactively solve problems",
          "Proficient in both French and English",
      ] },
      ]
      }
    },
  ];

  export default careers;